import type { History, LocationDescriptorObject, Path } from 'history'

/**
 * Skip one tick until redirecting to not possibly unmount a React Component
 * before it is done calling possible occurrences of setState or other internal methods
 */
export default function safeRedirect(history: History, location: LocationDescriptorObject | Path) {
  window.setTimeout(() => history.push(location))
}
